import React from 'react';
import AboutCompany1 from '../images/PageImg/about-company1.jpg';
import AboutCompany2 from '../images/PageImg/about-company2.jpg';
import { HlzOffice } from '../components/Office';
import { HlzFactory } from '../components/Factory';
import './AboutUs.css';

function AboutUs() {
  console.log("into AboutUs()");
  return (
    <div className='aboutus-page'>
      <header className='mt-5'>
        <div className='container h-100 d-flex align-items-center justify-content-center'>
          <h1 className='text-light'>About Us</h1>
        </div>
      </header>

      <div className='container my-5'>
        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Cupiditate dolores.</p>
        <div className='row'>
          <div className='col-lg-6'> <img src={AboutCompany1} className='img-fluid my-4' alt="" /> </div>
          <div className='col-lg-6'> <img src={AboutCompany2} className='img-fluid my-4' alt="" /> </div>
        </div>
        <p>Lorem essenulla, debitis similique,  blanditiis dibero rem.</p>
      </div>

      <div className='bg-dark text-light'> <HlzOffice /> </div>
      <div className='bg-dark text-light'> <HlzFactory /> </div>
    </div>
  )
}

export default AboutUs;